import styled from "styled-components";

export const Container = styled.div`
  max-width: 800px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
`;
